module.exports = __webpack_public_path__ + "img/ic_search_active.681b791b.svg";